import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/context/LangContext";

export default function StaffRewards() {
  const { t } = useLang();
  const [rewards, setRewards] = useState([]);
  useEffect(() => { api.get("/staff/rewards").then((r) => setRewards(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-6">
      <h1 className="font-serif-display text-4xl">{t.admin.rewards}</h1>
      <p className="text-white/60 text-sm">View-only. Only admin can approve or send rewards.</p>
      <div className="rounded-2xl bg-white/5 border border-white/10 overflow-hidden">
        {rewards.length === 0 ? (
          <div className="p-10 text-center text-sm text-white/60">No rewards yet.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="text-xs uppercase tracking-widest text-white/50 border-b border-white/10">
              <tr>
                <th className="text-left p-4">Ambassador</th>
                <th className="text-left p-4">#</th>
                <th className="text-left p-4">Reward</th>
                <th className="text-left p-4">Status</th>
              </tr>
            </thead>
            <tbody>
              {rewards.map((r) => (
                <tr key={r.id} data-testid={`staff-rew-row-${r.id}`} className="border-b border-white/5 last:border-0">
                  <td className="p-4">{r.ambassador?.name}<br/><span className="text-white/50 text-xs">{r.ambassador?.email}</span></td>
                  <td className="p-4">{r.type === "bonus" ? "—" : `#${r.referral_number}`} <span className="text-xs text-white/50">({r.level})</span></td>
                  <td className="p-4">{r.label_en}</td>
                  <td className="p-4"><span className="px-2 py-1 rounded-full bg-white/5 text-xs">{r.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
